/*eslint-disable */

import { bus } from '@/main';
import candidateLinkagePopup from '../candidates-linkage-with-q-bank-popup/';
import contestHistoryPopup from '../candidate-contest-histories-popup/';
import removeQbankFromCandidate from '../remove-qbank-from-cadidate-popup/';

export default {
  name: 'candidate-linkage-with-qbank-page-screen',
  components: {
    'candidate-linkage-popup' : candidateLinkagePopup,
    'remove-qbank-from-candidate-popup' : removeQbankFromCandidate,
    'contest-histories-popup':contestHistoryPopup
  },
  props: [],
  data () {
    return {
      linkageQBankInfo:null,
      linkageQBankInfoRslts:[],
      candidateLinkagePopupState:false,
      candidateLinkageId:'',
      removeQbankFromCandidatePopupState:false,
      removeQbankId:'',
      removeCandidateId:'',
      domainLocationOrigin:process.env.VUE_APP_PUBLIC_URL,
      contestCandidateId:'',
      contestQbankId:'',
      contestHistoriesPopupState:false,
    }
  },
  computed: {
  },
  mounted () {
    bus.$on('contestHistoriesPopupStateBus', (data) => {
      this.contestHistoriesPopupState = data
    })
    bus.$on('candidateLinkagePopupStateBus', (data) => {
      this.candidateLinkagePopupState = data
      this.getLinkageQbanksListMethod();
    })
    bus.$on('removeQbankFromCandidatePopupStateBus', (data) => {
      this.removeQbankFromCandidatePopupState = data
      this.getLinkageQbanksListMethod();
    })
    this.getLinkageQbanksListMethod();
    this.candidateLinkageId = this.$route.params.candidateId;
  },
  methods: {
    getLinkageQbanksListMethod(){
      this.$store.dispatch('getQbanksLinkToCandidateListForAdminAction', {id:this.$route.params.candidateId}).then((res) =>{
        this.linkageQBankInfo = res.data.data
        this.linkageQBankInfoRslts = this.linkageQBankInfo.results
      })
    },
    candidateLinkagePopupMethod(){
      this.candidateLinkagePopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    contestHistoriesPopupMethod(id){
      this.contestHistoriesPopupState = true
      this.contestQbankId = id;
      this.contestCandidateId = this.$route.params.candidateId;
      document.body.classList.add('body_right_scroll_remove')
    },
    removeQbankFromCandidatePopupMethod(item){
      this.removeQbankFromCandidatePopupState = true;
      this.removeQbankId = item.question_bank;
      this.removeCandidateId = this.$route.params.candidateId;
      document.body.classList.add('body_right_scroll_remove')
    },
    urlClipBoardMethod() {
      const copyUrl = this.domainLocationOrigin + '/interviewer/' + this.candidateLinkageId
      navigator.clipboard.writeText(copyUrl);
    },
  },
  watch: {
  },
}